import React from 'react'
import SalesOverview from '..'
import type { BasicWidgetProps } from '../../../types'

const SalesLastWeek: React.FC<BasicWidgetProps> = ({ widgetId, handleConfig, readonly }: BasicWidgetProps) => {
    return (
        <div data-test="LastWeek">
            <SalesOverview
                config={{ weekModifier: -1 }}
                widgetId={widgetId}
                handleConfig={handleConfig}
                readonly={readonly}
            />
        </div>
    )
}

export default SalesLastWeek
